import React from "react";
import styled from "@emotion/styled";
import ParkkiLogo from "images/parkki-logo.png";

const StyledImg = styled.img`
  width: auto;
  height: 50%;
  cursor: pointer;
`;

type Props = {
  onClick: React.MouseEventHandler<HTMLImageElement>;
};

function HeaderLogo({ onClick }: Props): JSX.Element {
  return <StyledImg onClick={onClick} src={ParkkiLogo} alt="Parkki" />;
}

export default HeaderLogo;
